
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { Search, Refresh, Clear, RemoveCircle, AddCircleOutlineOutlined, ManageSearch } from "@mui/icons-material";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import { useGetBuyerQuery, useGetBuyerListQuery, useGetBuyerPresentationQuery } from "../../../../timber/apis/Buyer.api";
import { BuyerNameDisplay, default as BuyerName } from "../../../../timber/components/buyer/BuyerDetail/BuyerName";
import { toString as toStringBuyer, PrimaryBuyer } from "../../../../timber/types/models/Buyer";

import { useGetContractorUserQuery, useGetContractorUserListQuery, useGetContractorUserPresentationQuery } from "../../../../timber/apis/ContractorUser.api";
import { ContractorUserNameDisplay, default as ContractorUserName } from "../../../../timber/components/contractorUser/ContractorUserDetail/ContractorUserName";
import { toString as toStringContractorUser, PrimaryContractorUser } from "../../../../timber/types/models/ContractorUser";
import React from "react";
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
    Container,
    Stack,
    Button,
    FormControl,
    Divider,
} from "@mui/material";

import { object, string, number, boolean, date, coerce, TypeOf, array } from 'zod';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import * as crudgen from "../../../../share";
import {formatDateTime, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import {useDebounce} from "react-use";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useDispatch} from "react-redux";
import useSearch from "../../../../hooks/useSearch";
import { Trans } from "@lingui/react/macro";
import { t, msg } from "@lingui/core/macro";

export const initialFormStateFn = () => { return {
    
    
    
    
    
        state: [],
        
    
        shipmentType: [],
        
    
        shippingContractorUserId: [],
        
    
} }

export const formObject = {
    
        key: string()
        .trim()
        .nullish(),
        
        
    
        reportKey: string()
        .trim()
        .nullish(),
        
        
    
            shipmentAtFrom: date().nullish(),
            shipmentAtTo: date().nullish(),
            
        
        
        shipmentAtInclude: boolean().default(false),
        
    
        buyerId: string()
            .nullish(),
        
        
        buyerIdInclude: boolean().default(false),
        
    
        state: array(string()
        .trim()
        .nullish()),
        
        
    
        shipmentType: array(string()
        .trim()
        .nullish()),
        
        
    
        shippingContractorUserId: array(string()
            .nullish()),
        
        
    
};

export const formSchema = object(formObject);

export type FormInput = TypeOf<typeof formSchema>;

type IProps = {
    prefix?: string;
    setSearchInputValue: (search: string) => void;
    searchInputAdvanced: any;
    setSearchInputAdvanced: (any) => void;
    query: any;
    refetch: () => void;
}

const ShipmentListSearch = (props: IProps) => {
    
    const {advancedSearch, search, updateSearch} = useSearch('Shipment')
    
    const [advanced, setAdvanced] = React.useState(advancedSearch);
    
    const {prefix = '', query} = props;
    
    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: advanced ? search : initialFormStateFn()
    });

    const {
        reset,
        watch,
        handleSubmit,
        formState: { isSubmitSuccessful },
    } = methods;
    
    
    const [, setBuyerInputValue, buyerInputTerm] = useSearchDebounce();
    const { data: buyerList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getBuyerListLoading,
        isFetching: getBuyerListFetching, 
    } = useGetBuyerPresentationQuery({
        list: {
            page: 0,
            pageSize: 12,
        },
        filter: {
            name: buyerInputTerm || '',
                    nameOr: true,
                    },
    })
    
    
    const [, setContractorUserInputValue, contractorUserInputTerm] = useSearchDebounce();
    const { data: contractorUserList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getContractorUserListLoading,
        isFetching: getContractorUserListFetching, 
    } = useGetContractorUserPresentationQuery({
        list: {
            page: 0,
            pageSize: 12,
        },
        filter: {
            email: contractorUserInputTerm || '',
                    emailOr: true,
                    name: contractorUserInputTerm || '',
                    nameOr: true,
                    },
    })
    
    
    
    const cancelSearch = React.useCallback((e: any) => {
        e.stopPropagation()
        props.setSearchInputAdvanced(undefined)
        setAdvanced(false)
    })
    
    const onAdvancedSubmitHandler: SubmitHandler<FormInput> = (values, e: any) => {
        props.setSearchInputAdvanced(values)
    };

    const buyerIdInclude = watch(prefix + 'buyerIdInclude');

    React.useEffect(() => {
        if (!advancedSearch) {
            props.setSearchInputValue(search)
        }
    }, []);

    const [advancedFormValues, setAdvancedFormValues] = React.useState(advanced ? search : initialFormStateFn())

    const [, cancelAdvancedFormValues] = useDebounce(() => {
        if (advanced) {
            handleSubmit(onAdvancedSubmitHandler)()
            updateSearch(advanced, advancedFormValues)
        }
    }, DEBOUNCE_TIME, [advancedFormValues, advanced])

    React.useEffect(() => {
        const subscription = watch((values) => {
            setAdvancedFormValues(values)
        });
        return () => {
            cancelAdvancedFormValues()
            subscription.unsubscribe()
        }
    }, [watch, cancelAdvancedFormValues]);
        
    if (!advanced)
    return (<Box
        component="form"
        onSubmit={(e) => {e?.preventDefault()}}
        noValidate
        sx={ { '& > :not(style)': { m: 1, width: '100%', padding: '1em' } } }
        autoComplete="off"
        data-testid="Shipment-search-form"
    >
        <TextField
            defaultValue={ !advancedSearch ? search : '' }
            label={t`Search (by Key, Report Key, Shipment At)`}
            onChange={ (event) => {
                props.setSearchInputValue(event.target.value)
                updateSearch(false, event.target.value)
            } }
            variant="standard"
            slotProps={ {
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => {
                                    props.setSearchInputValue('')
                                    updateSearch(false, '')
                                } }
                                edge="end"
                            >
                                <Clear />
                            </IconButton>
                            <IconButton
                                onClick={() => setAdvanced(!advanced)}
                                edge="end"
                            >
                                <ManageSearch />
                            </IconButton>
                            
                            <IconButton
                                onClick={props.refetch}
                                edge="end"
                            >
                                <Refresh />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            } }
        />
    </Box>)
    if (advanced)
        return (<Container sx={ { marginBottom: '1em' } }>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={handleSubmit(onAdvancedSubmitHandler)}
                    noValidate
                    data-testid="Shipment-advanced-search-form"
                >
                    <FormControl fullWidth size="small">
                        
        
            
            <crudgen.FormInput
                    
                    name={ prefix + 'key' }
                    label={t`Key`}
                    clearable={true}
                    
                    
                    type='text'
                    
            />
            
        
    

                        
        
            
            <crudgen.FormInput
                    
                    name={ prefix + 'reportKey' }
                    label={t`Report Key`}
                    clearable={true}
                    
                    
                    type='text'
                    
            />
            
        
    

                        
        
            
                
                <crudgen.FormDateRange
                    startName={ prefix + 'shipmentAtFrom' }
                    endName={ prefix + 'shipmentAtTo' }
                    startLabel={t`Shipment At From`}
                    endLabel={t`Shipment At To`}
                />
                
            
        
    

                        <Box sx={ {display: 'flex'} }>
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'buyerId' }
                optionsLoading={ getBuyerListLoading || getBuyerListFetching }
                label={t`Buyer`}
                options={ buyerList.items }
                valueMap={ (id) => useGetBuyerQuery(PrimaryBuyer.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringBuyer }
                onInputChange={ setBuyerInputValue }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><BuyerNameDisplay data={option}/></li>)
                } }
                disabled={ !!buyerIdInclude }
                
            
        />
        
    
<crudgen.FormCheckbox
        name={ prefix + 'buyerIdInclude' }
        icon={<AddCircleOutlineOutlined />}
        checkedIcon={<RemoveCircle />}
    />
</Box>
                        
        
            
            <crudgen.FormSelect
                    
                    name={ prefix + 'state' }
                    label={t`State`}
                    options={ ShipmentStatePairs }
                    optionLabelMap={ toStringShipmentState }
                    
                    multiple
            />
            
        
    

                        
        
            
            <crudgen.FormSelect
                    
                    name={ prefix + 'shipmentType' }
                    label={t`Shipment Type`}
                    options={ ShipmentTypePairs }
                    optionLabelMap={ toStringShipmentType }
                    
                    multiple
            />
            
        
    

                        
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'shippingContractorUserId' }
                optionsLoading={ getContractorUserListLoading || getContractorUserListFetching }
                label={t`Contractor User`}
                options={ contractorUserList.items }
                valueMap={ (id) => useGetContractorUserQuery(PrimaryContractorUser.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringContractorUser }
                onInputChange={ setContractorUserInputValue }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><ContractorUserNameDisplay data={option}/></li>)
                } }
                
                
                renderValue={(value, getItemProps) =>
                    value.map((option: any, index: number) => {
                        const { key: _key, ...tagProps } = getItemProps({ index })
                        return (
                            <crudgen.SelectChip key={index} {...tagProps}>
                                <ContractorUserName id={option}/>
                            </crudgen.SelectChip>
                        );
                    })
                }
                multiple
                
            
        />
        
    

                        
                        
                        <Stack direction="row" spacing={1}>
                            <Button size="small"  variant="outlined" color="primary" type='submit' sx={ {display: 'none'} }>
                                <Search /> <Trans>Search</Trans>
                            </Button>
                            <Button size="small"  variant="outlined" color="primary" onClick={props.refetch}>
                                <Refresh /> <Trans>Refresh</Trans>
                            </Button>
                            <Button size="small" variant="outlined" onClick={cancelSearch} color="inherit">
                                <Trans>Cancel</Trans>
                            </Button>
                        </Stack>
                    </FormControl>
                </Box>
            </FormProvider>
        </Container>)
    
}

export default ShipmentListSearch;
